export default __webpack_public_path__ + "static/media/python.c6bc2f4d.PNG";